<template>
  <div
    class="radio-group text-start"
    :data-qa="dataQa">
    <div
      v-if="header"
      :class="'h5-headline black--text text-start radio-group__header ' + header_class "
      :data-qa="`${dataQa}-header`">
      {{ header }}
    </div>
    <sRadioGroup
      v-model="model_val"
      class="radio-group__wrapper"
      :class="{'mt-2': header}"
      :data-qa="`${dataQa}-radio-group`"
      :disabled="disabled"
      :row="row"
      @change="change">
      <slot name="radio">
        <sRadio
          v-for="(item, n) in values"
          :key="n"
          :data-qa="`${dataQa}__item-${n}`"
          :disabled="disabled"
          :label="item.value">
          <span
            :class="[ label_class || ' mb-0 black--text h6-text ' ]">
            {{ item.label }}
          </span>
        </sRadio>
      </slot>
    </sRadioGroup>
  </div>
</template>
<script>
export default {
  name: 'radioGroup',
  props: {
    className: String,
    header: String,
    disabled: Boolean,
    items: Array,
    row: Boolean,
    model: [String, Boolean, Number],
    label_class: String,
    header_class: String,
    dataQa: {
      type: String,
      default: 'radio-group'
    }
  },
  computed: {
    model_val: {
      get() {
        return this.model
      },
      set(value) {
        this.$emit('update:model', value)
      }
    },
    values() {
      return this.items || [
        {value: true, label: this.$t('Tenders.Yes') },
        {value: false, label: this.$t('Tenders.No')}
      ]
    }
  },
  methods: {
    change(ev) {
      this.$emit('change', ev)
    }
  }
}
</script>
<style lang="scss">
.radio-group {
  .v-label {
    color: black !important;
    font-size: unset !important;
  }
  .v-input--selection-controls__input {
    margin-right: 4px;
    .v-icon {
      width: 20px;
      height: 20px;
      align-self: center;
    }
  }
  .v-input--selection-controls__ripple {
    height: 25px;
    width: 25px;
    top: calc(50% - 20px);
    left: -10px;
  }
}
</style>
